export default __webpack_public_path__ + "static/blob1-9ee3ed5b224dff53c9c131c84d00da26.svg";